import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./store";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
//import { msalConfig } from './externalAuth/authConfig';
import { msalConfig } from './components/login/authConfig';
import { msalConfigExternal } from './components/login/authConfigExternal';
import { LOGIN_GODREJ_EMPLOYEE } from "./utils/constant";

const msalInstance = new PublicClientApplication(msalConfig);
const msalInstanceExternal = new PublicClientApplication(msalConfigExternal);

if (!msalInstanceExternal.getActiveAccount() && msalInstanceExternal.getAllAccounts().length > 0) {
  msalInstanceExternal.setActiveAccount(msalInstanceExternal.getAllAccounts()[0]);
}

msalInstanceExternal.addEventCallback((event) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload.account
  ) {
    msalInstanceExternal.setActiveAccount(event.payload.account);
  }
});

const loginType = sessionStorage.getItem("LoginType");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
    <MsalProvider instance={(loginType === LOGIN_GODREJ_EMPLOYEE) || (loginType === null) ? msalInstance : msalInstanceExternal}>
      <App />
    </MsalProvider>
    {/* </React.StrictMode> */}
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
